import { useEffect, useState } from 'react'
import { Swiper as SwiperClass } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

const arrayShift = 10

const createSlides = (startNumber: number, shift = arrayShift) => {
  return [
    ...Array.from({ length: shift }).map((_, idx) => startNumber - arrayShift + idx),
    ...Array.from({ length: shift }).map((_, idx) => startNumber + idx)
  ].reverse()
}

const NumberSlider = ({ state }: { state: number | undefined }) => {
  const [slides, setSlides] = useState(() => createSlides(0))
  const [swiper, setSwiper] = useState<SwiperClass | undefined>(undefined)

  useEffect(() => {
    setSlides(prev => {
      const maxEl = prev[0]
      if (maxEl === undefined || maxEl === null || !state) return prev
      if (maxEl - state <= 0) {
        return createSlides(state)
      }
      return prev
    })
  }, [state])

  useEffect(() => {
    if (!swiper || swiper.destroyed || !state) return
    const idx = slides.indexOf(state)
    if (!idx) return
    if (idx === -1) return
    swiper.slideTo(idx)
  }, [slides, swiper, state])

  return (
    <div className=''>
      <Swiper
        direction={'vertical'}
        slidesPerView={5}
        spaceBetween={10}
        centeredSlides
        noSwiping
        allowTouchMove={false}
        onSwiper={setSwiper}
        className='NumberSwiper'
      >
        {slides.map((item, id) => {
          return (
            <SwiperSlide key={id}>
              <p className='text-[48px] font-bold leading-[140%] text-center  text-white transition-all duration-300 translate-y-0'>
                {item}
              </p>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export default NumberSlider
